import { useState, useEffect } from 'react';

export const useAvatar = (currentUser) => {
  const [avatarImage, setAvatarImage] = useState(null);

  // Load avatar image
  useEffect(() => {
    console.log("Loading avatar image for user:", currentUser);

    // Default avatar path - use a path that definitely exists in your assets
    const defaultAvatarPath = '/tybee-circle.png';

    // Function to load avatar from URL
    const loadAvatarFromUrl = (url) => {
      console.log("Attempting to load avatar from:", url);
      const img = new Image();
      img.src = url;

      img.onload = () => {
        console.log("Avatar image loaded successfully from:", url);
        setAvatarImage(img);
      };

      img.onerror = (error) => {
        console.error("Error loading avatar image from:", url, error);
        loadDefaultAvatar();
      };
    };

    // Function to load the default avatar
    const loadDefaultAvatar = () => {
      console.log("Loading default avatar from:", defaultAvatarPath);
      const defaultImg = new Image();
      defaultImg.src = defaultAvatarPath;
      defaultImg.onload = () => {
        console.log("Default avatar loaded successfully");
        setAvatarImage(defaultImg);
      };
      defaultImg.onerror = (error) => {
        console.error("Error loading default avatar:", error);
      };
    };

    // Try to get user from debug info if props are empty
    if (!currentUser || typeof currentUser !== 'object') {
      console.log("No current user in props, trying to get from debug element");
      const userDebugElement = document.getElementById('user-debug-info');
      if (userDebugElement) {
        try {
          const userData = JSON.parse(userDebugElement.textContent);
          console.log("Found user in debug element:", userData);

          // Check for avatar URL in the parsed user data
          if (userData && userData.avatar) {
            loadAvatarFromUrl(userData.avatar);
            return;
          }
        } catch (e) {
          console.error("Error parsing user debug data:", e);
        }
      }
      loadDefaultAvatar();
      return;
    }

    // If we have a user with an avatar, load it
    if (currentUser.avatar) {
      loadAvatarFromUrl(currentUser.avatar);
    } else {
      loadDefaultAvatar();
    }
  }, [currentUser]);

  return { avatarImage };
};
